const CURRENT_VISIT_LIST_URL = "/v1/current-visit/list";
const CURRENT_VISIT_SINGLE_URL = "/v1/current-visit/get";
const CURRENT_VISIT_ADD_URL = "/v1/current-visit/add";
const CURRENT_VISIT_UPDATE_URL = "/v1/current-visit/update";
const CURRENT_VISIT_DELETE_URL = "/v1/current-visit/delete";
const CURRENT_VISIT_CHANGE_STATUS_URL = "/v1/current-visit/change-status";

const CURRENT_VISIT_URL_LIST = {
    CURRENT_VISIT_LIST_URL,
    CURRENT_VISIT_SINGLE_URL,
    CURRENT_VISIT_ADD_URL,
    CURRENT_VISIT_UPDATE_URL,
    CURRENT_VISIT_DELETE_URL,
    CURRENT_VISIT_CHANGE_STATUS_URL,
};
export {CURRENT_VISIT_URL_LIST};
